import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import _ from 'lodash';
import styles from './BubbleLoader.module.scss';
const BubbleLoader = ({ className, mode, innerClassNames }) => {
    const preparedType = _.isArray(mode) ? mode : [mode];
    return (_jsx("div", { className: classNames('bubble-loader', innerClassNames, styles.bubbleLoader, preparedType.length > 0 && preparedType.map((x) => x).join(' '), className) }));
};
export default BubbleLoader;
